import parse from 'html-react-parser'
import React from 'react'
import { compose } from 'redux'

import { withModalService, withModalServiceProps } from 'services/utils/modal'

import { ModalBox, Typography } from 'components'
import { BasicModalProps } from 'modals'

import i18n from 'translations'

export interface TermsAndConditionsModalProps {
  content: string
}

type TermsAndConditionsModalFullProps = BasicModalProps & withModalServiceProps & TermsAndConditionsModalProps

const TermsAndConditionsModal: React.FC<TermsAndConditionsModalFullProps> = ({
  content,
  hideModal,
}) => {
  const handleCancelClick = () => {
    hideModal()
  }

  return (
    <ModalBox title={i18n.t('modals:TermsAndConditions:title')} onCloseClick={handleCancelClick}>
      <Typography>
        {parse(content)}
      </Typography>
    </ModalBox>
  )
}

const enhance = compose(
  withModalService,
)

export default enhance(TermsAndConditionsModal)
